import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import TabSwitcher from '../../molecules/TabSwitcher/view';
import './style.css';
import '../../styles/shared-redesign.css';

// Styling imports
import { Container } from 'react-bootstrap';
import { ArrowLeft } from 'lucide-react';

// Custom components and usecases
import { cancelSubscription } from '../../../usecases/subscriptions-usecase';
import { dispatchCustomEvent, listener } from '../../../utils/dispatch';
import ConfirmPopUp from '../../atoms/confirmPopUp/view';
import CollaboratorsManager from '../../organisms/CollaboratorsManager/CollaboratorsManager';
import ProfileForm from '../../organisms/ProfileForm/view';

// Context
import { roleContext } from '../../../context/role/context';

const ROLE_IDS = {
    INCOGNIT: 0,
    SUPER_ADMIN: 1,
    ADMIN: 2,
    CASHIER: 3,
    ACCOUNTANT: 4
};

function ProfilePage() {
    const { profile, suscripcion } = useContext(roleContext);
    const navigate = useNavigate();

    const [activeTabIndex, setActiveTabIndex] = useState(0); // 0: profile, 1: collaborators

    const resolvePlan = () => {
        if (profile?.plan) return profile.plan;
        if (suscripcion?.plan) return suscripcion.plan;
        return suscripcion;
    };

    const [plan, setPlan] = useState(resolvePlan());

    useEffect(() => {
        setPlan(resolvePlan());
    }, [suscripcion, profile]);

    useEffect(() => {
        const handleCancelEvent = () => handleCancel();
        listener("cancel-suscription", handleCancelEvent);
    }, [profile]);

    const handleCancel = () => {
        if (!profile) return;
        cancelSubscription(profile.uid, profile.cid).then((response) => {
            if (response) {
                dispatchCustomEvent("popup", { message: "✅ Suscripcion cancelada" });
            } else {
                dispatchCustomEvent("popup", { message: "❌ Error al cancelar la suscripcion" });
            }
        });
    };

    const roleId = profile?.colaborador?.role_id ?? profile?.role_id;
    const isAccountant = roleId === ROLE_IDS.ACCOUNTANT;
    const isCashier = roleId === ROLE_IDS.CASHIER;

    const goBack = () => {
        if (isAccountant) {
            navigate('/accountant-hub');
        } else if (isCashier) {
            navigate('/pos');
        } else {
            navigate('/hub');
        }
    };

    if (!profile) return <div>Cargando...</div>;

    const tabs = [
        {
            name: "Mi Perfil",
            component: () => (
                <ProfileForm
                    profile={profile}
                    plan={plan}
                    showSubscription={!isAccountant}
                />
            )
        }
    ];

    if (!isAccountant) {
        tabs.push({
            name: "Colaboradores",
            component: () => (
                <CollaboratorsManager />
            )
        });
    }

    return (
        <div className="profile-page-container">
            <header className="profile-header">
                <div className="header-back-section">
                    <div>
                        <h1 className="profile-title">{activeTabIndex === 0 ? 'Mi Perfil' : 'Colaboradores'}</h1>
                        <p className="profile-subtitle">
                            {activeTabIndex === 0
                                ? 'Gestiona tu información personal' + (!isAccountant ? ' y suscripción' : '')
                                : 'Gestiona los accesos de contadores y cajeros'}
                        </p>
                    </div>
                </div>
            </header>

            <Container className="profile-content">
                <TabSwitcher
                    onTabChange={setActiveTabIndex}
                    tabs={tabs}
                    hashKey="tab"
                />
            </Container>

            <ConfirmPopUp
                eventKey="cancel-suscription"
                onAcept={handleCancel}
                msg="¿Estás seguro de que deseas cancelar la suscripción? Esta acción no se puede deshacer."
            />
        </div>
    );
}

export default ProfilePage;
